import { render, staticRenderFns } from "./FreightTableAddRouteView.vue?vue&type=template&id=2fc36352&scoped=true"
import script from "./FreightTableAddRouteView.vue?vue&type=script&lang=js"
export * from "./FreightTableAddRouteView.vue?vue&type=script&lang=js"
import style0 from "./FreightTableAddRouteView.vue?vue&type=style&index=0&id=2fc36352&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc36352",
  null
  
)

export default component.exports